import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  productPriceClick,
  productClickOutBounce,
} from '../../actions/product';
import { AppState } from '../../../../reducers';
import { PriceListProps, PriceListStateProps } from './types';
import PriceListPanel from './price-list-panel';
import { HighlightedOffers } from '../product-highlighted-offer';

const PriceList: React.FC<PriceListProps> = props => {
  const {
    productId,
    category,
    me,
    prices,
    variantGroups,
    conditions,
    ...priceListPanelProps
  } = props;

  const { market } = useContext(AppContext);
  return (
    <>
      {prices?.highlights && (
        <HighlightedOffers
          productId={productId}
          categoryId={category?.id}
          highlights={prices?.highlights}
          campaign={props.campaign}
          priceDisplay={props.priceDisplay}
          media={priceListPanelProps.media}
        />
      )}
      <PriceListPanel
        me={me}
        productId={productId}
        showProductInformationTexts={market.showProductInformationTexts}
        prices={prices}
        storeStatistics={prices?.meta?.storeStatistics}
        category={category}
        variantGroups={variantGroups}
        conditions={conditions}
        {...priceListPanelProps}
      />
    </>
  );
};

const mapStateToProps = (state: AppState): PriceListStateProps => ({
  me: state.areas.account.me,
  priceDisplay: state.areas.product.priceDisplay,
  currentSorting: state.areas.product.sorting,
});

const dispatchProps = {
  dispatchProductPriceClick: productPriceClick,
  dispatchProductClickOutBounce: productClickOutBounce,
};

export default connect(mapStateToProps, dispatchProps)(PriceList);
